module.exports = __webpack_public_path__ + "static/img/870Z5G.0be907f5.png";